import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'features-account', en)

export * from './src/pages/savings'
export * from './src/pages/checking-details'
export * from './src/pages/debit-card'
export * from './src/pages/activate'
export * from './src/pages/debit-card-activate'
export * from './src/pages/debit-card-activate-success'
export * from './src/pages/debit-card-set-pin'
export * from './src/pages/savings-details'
export * from './src/pages/beneficiaries'
export * from './src/components'
export * from './src/pages/redesign'
